var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_632_1241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0898 9.49738H30.8386C30.07 4.5673 25.8065 0.78418 20.6662 0.78418C15.52 0.78418 11.2565 4.5673 10.4878 9.49738H4.23662C2.53115 9.49738 1.14404 10.8846 1.14404 12.5839V36.1175C1.14404 37.8228 2.53115 39.2161 4.23662 39.2161H37.0898C38.8012 39.2161 40.1884 37.8228 40.1884 36.1175V12.5839C40.1884 10.8846 38.8013 9.49738 37.0898 9.49738ZM20.6602 6.81918C23.0081 6.81918 24.9178 8.72879 24.9178 11.0768C24.9178 13.4246 23.0082 15.3283 20.6602 15.3283C18.3183 15.3283 16.4087 13.4247 16.4087 11.0768C16.4087 8.72871 18.3183 6.81918 20.6602 6.81918ZM23.0862 35.9073H18.2402C17.91 35.9073 17.6397 35.6371 17.6397 35.3068C17.6397 34.9765 17.91 34.7064 18.2402 34.7064H23.0862C23.4165 34.7064 23.6867 34.9765 23.6867 35.3068C23.6867 35.6371 23.4165 35.9073 23.0862 35.9073ZM38.9874 31.7999H2.34506V12.5839C2.34506 11.545 3.19178 10.6984 4.23662 10.6984H10.3677C10.3677 10.8305 10.3497 10.9626 10.3497 11.0947C10.3497 16.6133 19.7955 28.1308 20.1979 28.6173C20.3119 28.7554 20.4862 28.8395 20.6663 28.8395C20.8404 28.8395 21.0146 28.7554 21.1287 28.6173C21.531 28.1309 30.9769 16.6133 30.9769 11.0947C30.9769 10.9626 30.9589 10.8305 30.9589 10.6984H37.09C38.1348 10.6984 38.9876 11.5451 38.9876 12.5839V31.7999H38.9874Z",
    fill: "#009DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_632_1241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.666504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.4ce6865d7c761a2080f136903b465831.svg";
export { ForwardRef as ReactComponent };